// These semantic classes are adapter output only and are never part of persisted neutral JSON.
export const RICH_MEDIA_CONTRACT_VERSION = 1

export const RICH_MEDIA_CLASSES = Object.freeze({
  root: 'mg-rich-media',
  content: 'mg-rich-media__content',
  block: 'mg-rich-media__block',
  richText: 'mg-rich-media__block--rich-text',
  callout: 'mg-rich-media__callout',
  calloutKeyPoint: 'mg-rich-media__callout--key-point',
  calloutReminder: 'mg-rich-media__callout--reminder',
  calloutExample: 'mg-rich-media__callout--example',
  calloutLabel: 'mg-rich-media__callout-label',
  media: 'mg-rich-media__media',
  image: 'mg-rich-media__media--image',
  video: 'mg-rich-media__media--video',
  videoBox: 'mg-rich-media__video-box',
  caption: 'mg-rich-media__caption',
  divider: 'mg-rich-media__divider',
  state: 'mg-rich-media__state',
  unsupported: 'mg-rich-media__state--unsupported',
  loading: 'mg-rich-media__state--loading',
  error: 'mg-rich-media__state--error',
  offline: 'mg-rich-media__state--offline',
  update: 'mg-rich-media__update',
  completed: 'mg-rich-media__completed',
  control: 'mg-rich-media__control',
  node: 'mg-rich-media__node',
  textNode: 'mg-rich-media__node--text',
  paragraphNode: 'mg-rich-media__node--paragraph',
  headingNode: 'mg-rich-media__node--heading',
  listNode: 'mg-rich-media__node--list',
  listItemNode: 'mg-rich-media__node--list-item',
  blockquoteNode: 'mg-rich-media__node--blockquote',
  codeNode: 'mg-rich-media__node--code',
  fallbackNode: 'mg-rich-media__node--fallback',
  bold: 'mg-rich-media__mark--bold',
  italic: 'mg-rich-media__mark--italic',
  underline: 'mg-rich-media__mark--underline',
  strike: 'mg-rich-media__mark--strike'
})

export const RICH_MEDIA_BLOCK_TYPES = Object.freeze(['rich_text', 'callout', 'image', 'video', 'divider'])
export const RICH_MEDIA_NODE_TYPES = Object.freeze(['text', 'paragraph', 'heading', 'list', 'list_item', 'blockquote', 'code'])
export const RICH_MEDIA_CALLOUT_TONES = Object.freeze(['key_point', 'reminder', 'example'])

const calloutToneClasses = Object.freeze({
  key_point: RICH_MEDIA_CLASSES.calloutKeyPoint,
  reminder: RICH_MEDIA_CLASSES.calloutReminder,
  example: RICH_MEDIA_CLASSES.calloutExample
})

export function richMediaBlockClasses(type, tone) {
  if (type === 'rich_text') return [RICH_MEDIA_CLASSES.block, RICH_MEDIA_CLASSES.richText]
  if (type === 'image') return [RICH_MEDIA_CLASSES.block, RICH_MEDIA_CLASSES.media, RICH_MEDIA_CLASSES.image]
  if (type === 'video') return [RICH_MEDIA_CLASSES.block, RICH_MEDIA_CLASSES.media, RICH_MEDIA_CLASSES.video]
  if (type === 'divider') return [RICH_MEDIA_CLASSES.divider]
  if (type !== 'callout') return [RICH_MEDIA_CLASSES.state, RICH_MEDIA_CLASSES.unsupported]

  const normalizedTone = RICH_MEDIA_CALLOUT_TONES.includes(tone) ? tone : 'key_point'
  return [RICH_MEDIA_CLASSES.block, RICH_MEDIA_CLASSES.callout, calloutToneClasses[normalizedTone]]
}

export function richMediaNodeClasses(type) {
  if (type === 'text') return [RICH_MEDIA_CLASSES.textNode]
  if (type === 'paragraph') return [RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.paragraphNode]
  if (type === 'heading') return [RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.headingNode]
  if (type === 'list') return [RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.listNode]
  if (type === 'list_item') return [RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.listItemNode]
  if (type === 'blockquote') return [RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.blockquoteNode]
  if (type === 'code') return [RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.codeNode]
  return [RICH_MEDIA_CLASSES.node, RICH_MEDIA_CLASSES.fallbackNode]
}
